import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { MigrationResult } from './migration-result';
export var migrateV0ToV1 = function migrateV0ToV1(data) {
  var fallbackAsset = data.fallbackAsset,
      other = _objectWithoutProperties(data, ["fallbackAsset"]);

  var updatedFallbackAsset = fallbackAsset != null && fallbackAsset !== '' ? {
    assetType: (fallbackAsset === null || fallbackAsset === void 0 ? void 0 : fallbackAsset.includes('videos.datacamp.com')) ? 'Video' : 'Image',
    assetUrl: fallbackAsset
  } : null;
  return new MigrationResult('v1', _objectSpread(_objectSpread({}, other), {}, {
    fallbackAsset: updatedFallbackAsset
  }));
};
export var migrations = {
  v0: migrateV0ToV1
};
export default migrations;